<template src="./template.html"></template>

<script>
  import { isMobile } from 'mobile-device-detect'
  export default {
    name: 'GroupTopics',
    props: {
      topics: Array,
      group: Number,
    },
    data() {
      return {
        isMobile: isMobile,
        maximumRecordsToShow: 5,
      }
    },
    computed: {
      showMore() {
        return this.maximumRecordsToShow < this.topics.length
      },
    },
    created() {
      if (this.isMobile) {
        this.maximumRecordsToShow = 3
      }
    },
    methods: {
      viewMore() {
        if (this.isMobile) {
          this.maximumRecordsToShow += 3
        } else {
          this.maximumRecordsToShow += 5
        }
      },
    },
  }
</script>
